import { IADBanner } from '@components/shared/ADBanner/types';

/**
 * BANNER_ARRAY wraps the list in an object, unlike BANNER which returns the banner directly.
 */
export interface ADBannerListAdapter {
	Banners: IADBanner[] | null;
}

export const getADBannersAdapter = (data: ADBannerListAdapter): IADBanner[] => data?.Banners ?? [];
